function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import cx from "classnames";
import { twMerge } from "../../../utils/twMerge";
export function Button(props) {
    var tmp = props.as, As = tmp === void 0 ? "button" : tmp, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant, _theme = props.theme, theme = _theme === void 0 ? "default" : _theme, icon = props.icon, className = props.className, children = props.children, rest = _objectWithoutProperties(props, [
        "as",
        "variant",
        "theme",
        "icon",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(As, _extends({
        className: twMerge(cx("py-4 px-6 text-sm leading-normal font-medium transition-all flex items-center justify-center rounded-full", variant === "primary" && theme === "default" && "border border-brand-primary-base bg-brand-primary-base text-fg-inverted dark:text-fg-default dark:hover:text-fg-inverted hover:bg-bg-inverted hover:border-bg-inverted", variant === "primary" && theme === "secondary" && "border border-brand-secondary-base bg-brand-secondary-base text-fg-inverted hover:bg-bg-inverted hover:border-bg-inverted", variant === "primary" && theme === "light" && "border border-brand-primary-base bg-brand-primary-base text-fg-inverted dark:text-fg-default hover:bg-bg-default hover:border-bg-default hover:text-fg-default", variant === "secondary" && theme === "default" && "border border-fg-default text-brand-primary-base hover:text-fg-inverted hover:bg-bg-inverted hover:border-bg-inverted", variant === "secondary" && theme === "secondary" && "border border-fg-default text-brand-secondary-base hover:text-fg-inverted hover:bg-bg-inverted hover:border-bg-inverted", variant === "secondary" && theme === "light" && "border border-fg-inverted text-fg-inverted dark:text-fg-default dark:hover:bg-bg-inverted dark:hover:text-fg-inverted hover:text-brand-primary-base hover:bg-bg-default", className))
    }, rest), !!icon && /*#__PURE__*/ React.createElement("span", {
        className: "flex flex-col mr-3 shrink-0 [&>svg]:h-[1em] [&>svg]:w-auto"
    }, icon), /*#__PURE__*/ React.createElement("span", null, children));
}

//# sourceMappingURL=Button.js.map